import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import {
    ICoverTransition,
    ICutTransition,
    IFadeTransition,
    IFlashTransition,
    IFlipTransition,
    IGalleryTransition,
    INewsflashTransition,
    IPrismTransition,
    IPullTransition,
    IPushTransition,
    ISwitchTransition,
    IWarpTransition,
} from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { SideDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/side-direction';
import {
    EightDirectionType,
    InOutDirectionType,
    SideDirectionType,
    SwitchDirectionType,
} from '@src/slide/domain/ui-model/element-modeles/transition/direction/constants';
import { SwitchDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/switch-direction';
import { EightDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/eight-direction';
import { InOutDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/in-out-direction';

const pushPreset: IPushTransition = {
    direction: new SideDirection(SideDirectionType.UP),
    duration: 1000,
};

const fadePreset: IFadeTransition = {
    duration: 700,
};

const switchPreset: ISwitchTransition = {
    direction: new SwitchDirection(SwitchDirectionType.RIGHT),
    duration: 1250,
};

const cutPreset: ICutTransition = {
    duration: 100,
};

const pullPreset: IPullTransition = {
    direction: new EightDirection(EightDirectionType.RIGHT),
    duration: 750,
};

const coverPreset: ICoverTransition = {
    direction: new EightDirection(EightDirectionType.LEFT),
    duration: 1000,
};

const warpPreset: IWarpTransition = {
    direction: new InOutDirection(InOutDirectionType.IN),
    duration: 900,
};

const flipPreset: IFlipTransition = {
    direction: new SwitchDirection(SwitchDirectionType.LEFT),
    duration: 1250,
};

const galleryPreset: IGalleryTransition = {
    direction: new SwitchDirection(SwitchDirectionType.LEFT),
    duration: 1600,
};

const prismPreset: IPrismTransition = {
    direction: new SideDirection(SideDirectionType.LEFT),
    duration: 1200,
};

const flashPreset: IFlashTransition = {
    duration: 1000,
};

const newsflashPreset: INewsflashTransition = {
    duration: 1500,
};

export const TransitionPresets = {
    [TransitionType.EMPTY]: {},
    [TransitionType.FADE]: fadePreset,
    [TransitionType.PUSH]: pushPreset,
    [TransitionType.SWITCH]: switchPreset,
    [TransitionType.CUT]: cutPreset,
    [TransitionType.PULL]: pullPreset,
    [TransitionType.COVER]: coverPreset,
    [TransitionType.WARP]: warpPreset,
    [TransitionType.FLIP]: flipPreset,
    [TransitionType.GALLERY]: galleryPreset,
    [TransitionType.PRISM]: prismPreset,
    [TransitionType.FLASH]: flashPreset,
    [TransitionType.NEWSFLASH]: newsflashPreset,
};
